import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'

import { Button } from '@/components/ui/button'
import { ApiError } from '@/lib/api/api-error'
import { paths } from '@/app/router/paths'

function describe(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return { title: `${error.status}`, message: error.statusText || 'Route failed to load.' }
  }
  if (error instanceof ApiError) {
    return { title: 'Request failed', message: error.message }
  }
  if (error instanceof Error) {
    return { title: 'Something broke', message: error.message }
  }
  return { title: 'Something broke', message: 'An unexpected error occurred.' }
}

/** Rendered by the router whenever a route element or lazy import throws. */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()
  const { title, message } = describe(error)

  return (
    <div className="flex min-h-96 flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">{title}</h1>
        <p className="text-muted-foreground text-body">{message}</p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => void navigate(0)}>
          Retry
        </Button>
        <Button onClick={() => void navigate(paths.projects.pipeline)}>Go to the pipeline</Button>
      </div>
    </div>
  )
}
